import { TDWActionType, TDWModuleType, TDWOperationType } from '../report/offline-data-report/constant';
import { tdw } from '../report/offline-data-report/tdw-report';

/**
 * 添加 html 根元素相对于浏览器视口的非正常偏移监测和上报
 * 通过监测 html 元素和视口的重叠程度来判断是否有非正常偏移
 * Intersection Observer API 文档：https://developer.mozilla.org/zh-CN/docs/Web/API/Intersection_Observer_API
 * @returns
 */
export default function createHTMLViewportOffsetObserve() {
    if (!('IntersectionObserver' in window)) {
        return;
    }
    try {
        const rootElement = document.documentElement;
        const options = {
            // 设置视口作为 root
            root: null,
            // 阈值设置的更细致一点，保证稍微有非正常偏移都可以监测到
            threshold: createThreshold(),
        };

        const intersectionObserver = new IntersectionObserver((entries) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const entry of entries) {
                if (entry.target === rootElement) {
                    const boundingClientRect = entry.boundingClientRect || rootElement.getBoundingClientRect();
                    const { left = 0, top = 0 } = boundingClientRect;
                    if (left !== 0 || top !== 0) {
                        // html 根元素有相对于视口有非正常偏移
                        try {
                            tdw({
                                opername: TDWOperationType.PPT_QUALITY,
                                module: TDWModuleType.HTML_DOCUMENT,
                                action: TDWActionType.HTML_ABNORMAL_OFFSET,
                                ver6: JSON.stringify({
                                    htmlBoundingClientRect: boundingClientRect,
                                }),
                            });
                        } catch (error) {
                            window.log.error(`[HTML abnormal offset observer callback error]: ${error}`);
                        }
                    }
                }
            }
        }, options);

        intersectionObserver.observe(rootElement);
    } catch (error) {
        window.log.error(`[createHTMLViewportOffsetObserve error]: ${error}`);
    }
}

function createThreshold() {
    const threshold: number[] = [];
    for (let i = 0; i <= 1.0; i += 0.01) {
        threshold.push(i);
    }
    return threshold;
}
